import SessionHelper from "./SessionHelper";

export default class UserHelper {

    static treatName(string, id, withSeparator = true) {
        if (id == SessionHelper.getFirebaseAuth().uid) return 'Você';

        string = string.toLowerCase();
        string = string.charAt(0).toUpperCase() + string.slice(1);
        string = string.split(/\s/);

        return `${string[0]}${string[string.length - 1][0] ? ` ${string[string.length - 1][0].toUpperCase()}${withSeparator ? '.' : ''}` : ''}`;
    }
}